.workflowTitle {
    color: rgb(24, 116, 190);
    font-weight: 750;
}

.defaultTitle {
    color: #616161;
    font-weight: 750;
}

.icon {
    color: white;
    width: 1.1rem;
    height: 1.1rem;
    margin-left: 0.24rem;
    margin-top: 0.2rem;

}

.workflowIconBackground {
    background-color: rgb(24, 116, 190);
}

.defaultIconBackground {
    background-color: #616161;
}

.iconBackground {
    border-radius: 50%;
    width: 1.5rem;
    height: 1.5rem;
    margin-top: 0.25rem;
    margin-right: 0.5rem;
}

.workflowContainer {
    border-color: rgb(24, 116, 190);
    background-color: #E6EEF7;
}

.defaultContainer {
    border-color: #616161;
    background-color: #F2F2F2;
}

.container{
    padding: 0 0.5rem 0 0.25rem;
    border-radius: 0.25rem;
    border-width: 1px;
    border-style: solid;
    display: flex;
}

.defaultTextsColumn{
    display: flex;
    flex-direction: column;
    line-height: 1;
}

.defaultDescription{
    color: #616161;
    font-weight: 300;
    font-size: 14px;
    padding-bottom: 2px;
}
